import { useState, useEffect, Ref, forwardRef } from 'react';
import CreatableSelect from 'react-select/creatable';
import Select, {
  components as componentsdata,
  GetOptionLabel,
  GetOptionValue,
  GroupBase,
  InputActionMeta,
  OptionProps,
  Options,
} from 'react-select';
import classNames from 'classnames/bind';
import { SelectComponents } from 'react-select/dist/declarations/src/components';
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import SvgCloseStatus from '../../icons/SvgClosestatus';
import LabelWrapper from '../Label/LabelWrapper';
import { isEmpty } from '../helper';
import {
  customStyles,
  customStylesLine,
  customStylesMulti,
  selectTagTheme,
  customStylechanges,
  customStyletrue,
  customStylechanges1,
  customStylechanges2,
  customStylesMulti1,
  customStylesMulti2,
  customStylesMulti3,
  customStylesMulti4,
  customStyleforcreatestages
} from './selectHelper';
import styles from './selecttag.module.css';


const cx = classNames.bind(styles);

export type list = {
  [key: string]: any;
};

type Props = {
  options: list[];
  isClearable?: boolean;
  isDisabled?: boolean;
  isSearchable?: boolean;
  isLoading?: boolean;
  placeholder?: string;
  isMulti?: boolean;
  onChange?: (a: any, b?: any) => void;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
  value?: string | number | any;
  name?: string;
  required?: boolean;
  label?: string;
  labelBold?: boolean;
  selectContainerClass?: string;
  defaultValue?: { label: string; value: string | number | any };
  components?: Partial<SelectComponents<any, boolean, GroupBase<any>>>;
  lineStyle?: boolean;
  stylechangess?: boolean;
  stylechangess1?: boolean;
  linechange?: boolean;
  id?: string;
  isOptionSelected?: (option: any, selectValue: Options<any>) => boolean;
  onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
  getOptionLabel?: GetOptionLabel<any>;
  getOptionValue?: GetOptionValue<any>;
  noOptionsMessage?: (obj: { inputValue: string }) => React.ReactNode;
  filterOption?:
  | ((option: FilterOptionOption<any>, inputValue: string) => boolean)
  | null
  | undefined;
  isCreate?: boolean;
  error?: boolean;
  errorMessage?: string;
  menuIsOpen?: boolean;
  autoFocus?: boolean;
  inputId?: string;
  stylechanges?: boolean;
  width?: boolean;
  skillwidth?: boolean;
  filter?: boolean;
  skillHeight?: boolean;
  onDeleteoption?: (a?: any) => void;
  Deletecomponent?: boolean;
  createstage?: boolean;
};

const SelectTag = (
  {
    isLoading,
    options,
    isClearable,
    isDisabled,
    isSearchable = false,
    placeholder,
    isMulti,
    onChange,
    onMenuOpen,
    onMenuClose,
    stylechanges,
    stylechangess,
    stylechangess1,
    value,
    name,
    required,
    label,
    labelBold,
    selectContainerClass,
    defaultValue,
    components,
    lineStyle,
    linechange,
    id,
    isOptionSelected,
    onInputChange,
    getOptionLabel,
    getOptionValue,
    noOptionsMessage,
    filterOption,
    isCreate,
    error,
    errorMessage,
    menuIsOpen,
    autoFocus,
    inputId,
    width,
    skillwidth,
    filter,
    skillHeight,
    onDeleteoption,
    Deletecomponent,
    createstage
  }: Props,
  ref: Ref<any> | undefined,
) => {
  const [isSelectStyle, setSelectStyle] = useState(customStyles);
  useEffect(() => {
    if (isMulti) {
      if (width) {
        setSelectStyle(customStylesMulti1)
      } else if (skillwidth) {
        setSelectStyle(customStylesMulti2)
      } else if (filter) {
        setSelectStyle(customStylesMulti3)
      }
      else if (skillHeight) {
        setSelectStyle(customStylesMulti4)
      }
      else {
        setSelectStyle(customStylesMulti)
      }
    } else if (stylechanges && !isMulti && !lineStyle && linechange) {
      setSelectStyle(customStylechanges);
    } else if (lineStyle) {
      setSelectStyle(customStylesLine);
    } else if (linechange && !isMulti && !lineStyle) {
      setSelectStyle(customStyletrue);
    } else if (stylechangess) {
      setSelectStyle(customStylechanges1);
    } else if (stylechangess1) {
      setSelectStyle(customStylechanges2);
    } else if (!isMulti && !lineStyle) {
      setSelectStyle(customStyles);
    }
    if (createstage) {
      setSelectStyle(customStyleforcreatestages);
    }

  }, []);

  // the option function for only show the option in profile view with status delete option.
  const Option = (props: OptionProps) => {
    const { children, ...restProps } = props;
    const val = restProps?.options;
    const val1 = (restProps as any)?.value; 
    const filterValue = val.filter((datas: any) => {
      if (restProps && 'value' in restProps && datas.value === restProps.value) {
        return true;
      }
      return false;
    });

    // function for deleting the perticular stage status.
    const handleDeleteClick = (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      if ((filterValue[0] as any)?.stageused === false) {
        onDeleteoption(val1);
      }
    };
    // Define a simple CSS class for the cursor style
    const stylespointer = {
      cursorPointer: {
        cursor: 'pointer',
      },
      cursorDefault: {
        cursor: 'default',
      },
      cursorNotallow: {
        cursor: 'not-allowed !important',
      }
    };

    // condition for cross icon cursor handling based on the stage status used or not in pipeline.
    const cursorStyle = (filterValue[0] as any)?.stageused === false ? stylespointer.cursorPointer : stylespointer.cursorDefault;

    return (
      <componentsdata.Option {...restProps} isDisabled={(filterValue[0] as any)?.value === 1}
        className={(filterValue[0] as any)?.value === 1 && (restProps as any)?.isSelected === false ? styles.disabledoption : styles.disabledoption1}>
        <Flex row between center marginRight={10} disabled={(filterValue[0] as any)?.value === 1}
          style={(filterValue[0] as any)?.value === 1 ? { cursor: 'not-allowed' } : {}}
        >
          <Flex>{children}</Flex>
          {(filterValue[0] as any)?.id === true &&
            <Flex
              center
              title={(filterValue[0] as any)?.stageused === true && 'Once set, the status cannot be removed.'}
              onClick={(e) => {
                handleDeleteClick(e)
              }
              } style={cursorStyle}>
              <SvgCloseStatus />
            </Flex>
          }
        </Flex>
      </componentsdata.Option >
    );
  };

  return (
    <Flex className={selectContainerClass}>
      <LabelWrapper required={required} label={label} bold={labelBold} >
        {isCreate ? (
          <CreatableSelect
            inputId={inputId}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={autoFocus}
            ref={ref}
            id={id}
            defaultValue={defaultValue}
            value={value}
            name={name}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isSearchable={isSearchable}
            isClearable={isClearable}
            options={options}
            placeholder={placeholder}
            isMulti={isMulti}
            onChange={onChange}
            styles={isSelectStyle}
            theme={(theme) => selectTagTheme(theme)}
            components={Deletecomponent ? { Option } : components}
            isOptionSelected={isOptionSelected}
            onInputChange={onInputChange}
            filterOption={filterOption}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            noOptionsMessage={noOptionsMessage}
            menuIsOpen={menuIsOpen}
          />
        ) : (
          <Select
            inputId={inputId}
            ref={ref}
            id={id}
            defaultValue={defaultValue}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            value={value}
            name={name}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isSearchable={isSearchable}
            isClearable={isClearable}
            options={options}
            placeholder={placeholder}
            isMulti={isMulti}
            onChange={onChange}
            styles={isSelectStyle}
            theme={(theme) => selectTagTheme(theme, error, errorMessage)}
            components={components}
            isOptionSelected={isOptionSelected}
            onInputChange={onInputChange}
            filterOption={filterOption}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            noOptionsMessage={noOptionsMessage}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={autoFocus}
          />
        )}
        {!isEmpty(errorMessage) && error && (
          <Text size={12} color={'error'} className={cx('errorMessageStyle')}>
            {errorMessage}
          </Text>
        )}
      </LabelWrapper>
    </Flex>
  );
};

export default forwardRef(SelectTag);
